// extracted by mini-css-extract-plugin
export var divider = "_r7-0";
export var systemMessage = "_r7-1";